// contexts/pedidos/PedidoItemContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext'; // Importa o contexto de alertas
import { useMessage } from '../geral/MessageContext'; // Importa o contexto de mensagens
import { PedidoItem } from '../../models/pedidos/PedidoItem';

const PedidoItemContext = createContext();

export const usePedidoItem = () => useContext(PedidoItemContext);

export const PedidoItemProvider = ({ children }) => {
    const [pedidoItens, setPedidoItens] = useState([]);
    const { showAlert } = useAlert(); // Acessa showAlert do AlertContext
    const { showMessage } = useMessage(); // Acessa showMessage do MessageContext
    const [pedidoItemSel, setPedidoItemSel] = useState(new PedidoItem());

    const fetchPedidoItens = useCallback(async (pedidoId) => {
        if (!pedidoId) return; // Não busca se não houver pedidoId
        try {
            const result = await fetchData(`/PedidoItem/GetByPedidoId`, { pedidoId }); // Endpoint para buscar itens por pedido
            setPedidoItens(result || []);            
        } catch (error) {
            console.error("Erro ao buscar itens do pedido:", error);
            showMessage(`Erro ao buscar itens do pedido! ${error?.message || error}`, 'danger');
        }
    }, []); // Dependências de fetchPedidoItens

    // useEffect(() => {
    //     fetchPedidoItens();
    // }, [fetchPedidoItens]); // fetchPedidoItens como dependência

    const addPedidoItem = async (pedidoItem) => {
        try {
            const result = await postData('/PedidoItem', pedidoItem);
            setPedidoItens([...pedidoItens, result]);
            showAlert('Item do pedido adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar item do pedido:", error);
            showMessage('Erro ao adicionar item do pedido!\n' + error, 'danger');
        }
    };

    const updatePedidoItem = async (pedidoItem) => {
        try {
            const result = await putData('/PedidoItem', pedidoItem);
            setPedidoItens((pedidoItens) =>
                pedidoItens.map((pi) => (pi.id === result.id ? result : pi))
            );
            showAlert('Item do pedido alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar item do pedido:", error);
            showAlert('Erro ao alterar item do pedido!', 'danger');
        }
    };

    const deletePedidoItem = async (id) => {
        try {
            await deleteData('/PedidoItem', { id }); // Passa o ID como parâmetro
            const novosItens =  pedidoItens.filter(pi => pi.id !== id);
            setPedidoItens(novosItens);             
            showAlert('Item do pedido excluído com sucesso!');
            return novosItens;                  
        } catch (error) {
            console.error("Erro ao excluir item do pedido:", error);
            showAlert('Erro ao excluir item do pedido!', 'danger');
        }
    };

    return (
        <PedidoItemContext.Provider value={{ pedidoItens, setPedidoItens, pedidoItemSel, setPedidoItemSel, addPedidoItem, updatePedidoItem, deletePedidoItem, fetchPedidoItens }}>
            {children}
        </PedidoItemContext.Provider>
    );
};